<template>
   <div class="  is-fullheight sticky-sidebar" >
     <aside class="menu column  aside   is-fullheight" >
      <p class="menu-label">
        Finance
      </p>
      <ul class="menu-list">
        <li>
          <a class="">Ordering</a>
          <ul>
            <li @click="activeMenuLink = 'finance/internal-orders'"><router-link to="/finance/internal-orders"  :class="{'is-active':activeMenuLink === 'finance/internal-orders'}">Internal Orders</router-link></li>
            
          </ul>
        </li>

        <li>
          <a class="">Reports</a>
          <ul>
            <li @click="activeMenuLink = 'finance/dublin-internal-report'"><router-link to="/finance/dublin-internal-report"  :class="{'is-active':activeMenuLink === 'finance/dublin-internal-report'}">Dublin Internal Report</router-link></li>
            
          </ul>
        </li>
        

        
      </ul>
      
    </aside>
    
   </div>
</template>

<script>
import OrderMixin from "@/mixins/OrderMixin.js";
//import OrderService from '@/services/OrderService.js';

export default {
  name: 'SideBarFinance',
  components: {
  },
  mixins: [OrderMixin],
  data() {
    return { activeMenuLink: null,
    }
  },
  methods: {
      
  },
  created() {
     this.getAccessToken()
        .then(() => { 
           
        });

        
  },
  mounted() {
    this.activeMenuLink = this.$route.path.substring(1)
    console.log(this.$route.path)

   
  }
}

</script>



